import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { leaveLanding, recordRolePage } from '@/auth/rolePages';

/**
 * Records every in-app navigation as the active role's last page (auth/rolePages.ts). Rendered
 * by RoleGate once the role is confirmed, so it never notes a page under a role that is not
 * active yet; it follows only the address, so a role that changes under the page on screen (a
 * switch loading the next role's data) does not get that page.
 */
export const RolePageRecorder = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    leaveLanding(pathname);
    recordRolePage(`${pathname}${search}`);
  }, [pathname, search]);

  return null;
};

export default RolePageRecorder;
